storefrontApp.service("UIService", [function () {
    return {
        scrollToTop: function () {
            window.scrollTo(0, 0);
            return true;
        }
    }
}]);
